import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";

import { useParams } from 'react-router-dom';

import { Input } from "../../../components/Input/input";
import { StyledButton } from "../../../components/Button/button";

import { Description, FormHeading, FormWrapper, ImgSVG, ViewBody } from "../forgotten-password-send-mail/styles";
import { forgottenPasswordUpdate } from "../../../services/account/forgotten-password-update";
import { ForgottenPasswordUpdateRequestBody } from "../../../services/account/forgotten-password-update/types";
import Icon from "../../../components/icon";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { LayoutAccount } from '../../../components/layoutAccount';




export const ForgottenPasswordUpdate = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { token } = useParams();
    let navigate = useNavigate();

    const forgottenPasswordUpdateMutation = useMutation(forgottenPasswordUpdate, {

        onSuccess: (res) => {
            navigate("/login")
        },
    });

    const validationSchema = yup.object().shape({
        haslo: yup.string()
            .min(8, 'Za którkie hasło')
            .max(50, 'Za długie hasło')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?&/<>.:;“'])[A-Za-z\d#$@!%&*?&/<>.:;“']{8,50}$/, 'Zaproponowane hasło nie spełnia założonych kryteriów.')
            .required("Pole wymagane"),

        confirm_password: yup.string()
            .when("haslo", {
                is: (val: any) => (val && val.length > 0 ? true : false),
                then: yup.string().oneOf(
                    [yup.ref("haslo")],
                    "Niezgodność haseł"
                ),
            })
            .required("Pole wymagane"),
    });

    const formik = useFormik({
        initialValues: {
            token: "",
            haslo: "",
            confirm_password: "",
        },
        validationSchema: validationSchema,

        onSubmit: (values: ForgottenPasswordUpdateRequestBody) => {

            const body =
            {
                haslo: btoa(values.haslo),
                token: token,
                confirm_password: btoa(values.confirm_password),
            }

            handleSubmitForgottenPasswordUpdate(body);
        },

    });

    const handleSubmitForgottenPasswordUpdate = (body: ForgottenPasswordUpdateRequestBody) => {
        forgottenPasswordUpdateMutation.mutate(body);
    };
    // if (forgottenPasswordUpdateMutation.isLoading) {
    //     return <LoadingBackDrop loading={true} />;
    // }

    return (
        <LayoutAccount>
            <form onSubmit={formik.handleSubmit}>
                <FormWrapper>
                    <FormHeading>Zdefiniuj nowe hasło</FormHeading>
                    <Description>Nowe hasło powinno posiadać od 8 do 50 znaków, w  tym  co najmniej: 1 - dużą literę, 1 - małą literę, 1 - cyfrę, 1 - znak specjalny.
                    </Description>
                    <Input
                        label="Nowe hasło"
                        id="haslo"
                        name="haslo"
                        type={showPassword ? "text" : "password"}
                        value={formik.values.haslo}
                        onChange={formik.handleChange}
                        error={formik.touched.haslo && Boolean(formik.errors.haslo)}
                        helperText={formik.touched.haslo && formik.errors.haslo}
                        onBlur={formik.handleBlur}
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle haslo visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        variant="filled"
                    />
                    <Input
                        label="Powtórz nowe hasło"
                        id="confirm_password"
                        name="confirm_password"
                        type={showConfirmPassword ? "text" : "password"}
                        value={formik.values.confirm_password}
                        onChange={formik.handleChange}
                        error={formik.touched.confirm_password && Boolean(formik.errors.confirm_password)}
                        helperText={formik.touched.confirm_password && formik.errors.confirm_password}
                        onBlur={formik.handleBlur}
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle confirm_password visibility"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        edge="end"
                                    >
                                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        variant="filled"
                    />
                    <StyledButton
                        type="submit"
                        variant="contained"
                        disabled={Boolean(formik.errors.haslo) || Boolean(formik.errors.confirm_password)}
                    >
                        Zapisz
                    </StyledButton >

                </FormWrapper>
            </form >
        </LayoutAccount>
    );


}

